<template>
  <div class="box">
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
    >
      <el-form-item label="标题:">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="封面:">
        <el-upload
          action="#"
          :on-change="getFile"
          class="avatar-uploader"
          :show-file-list="false"
        >
          <img
            v-if="imageUrls"
            :src="imageUrls"
            class="avatar"
          >
          <i
            v-else
            class="el-icon-plus avatar-uploader-icon"
          ></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="描述:">
        <el-input
          type="textarea"
          v-model="form.desc"
        ></el-input>
      </el-form-item>
      <el-form-item label="轮播图:">
        <el-upload
          action="#"
          :on-change="getFiles"
          class="avatar-uploader"
          :show-file-list="false"
        >
          <img
            v-if="imageUrlss"
            :src="imageUrlss"
            class="avatar"
          >
          <i
            v-else
            class="el-icon-plus avatar-uploader-icon"
          ></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="排序:">
        <el-input v-model="form.list_order"></el-input>
      </el-form-item>
      <el-form-item label="导航排序:">
        <el-input v-model="form.nav_order"></el-input>
      </el-form-item>
      <el-form-item label="状态:">
        <el-select
          v-model="form.status"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="搜索导航显示:">
        <el-select
          v-model="form.is_nav"
          placeholder="请选择"
        >
          <el-option
            v-for="item in optionss"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="专题模板:">
        <el-select v-model="form.template" placeholder="请选择">
          <el-option v-for="item in templateOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          style="background-color: #009688;"
          type="primary"
          @click="onSubmit"
        >保存</el-button>
        <el-button @click="nosubmit">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "Ztmeet",
  data () {
    return {
      imageUrls: '',
      imageUrlss: "",
      options: [{
        value: 0,
        label: '禁用'
      }, {
        value: 1,
        label: '正常'
      }, {
        value: -1,
        label: '删除'
      }],
      optionss: [{
        value: 0,
        label: '不显示'
      }, {
        value: 1,
        label: '显示'
      }],
      templateOption:[
        {
          label:'默认模板',
          value: 1,
        },
        {
          label:'鸣沙模板',
          value: 2,
        },
      ],
      form: {
        "id": "",
        "title": '',
        "desc": "",
        "cover_url": "",
        "banner": "",
        "list_order": "",
        "status": 1,
        "nav_order": "",
        "is_nav": "",
        "template":1,//模板
      }
    }
  },
  created () {
    this.form.id = this.$route.query.editId;
  },
  mounted () {
    if (this.form.id)
    {
      this.getedit()
    }

  },
  methods: {
    /* base64上传 */
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    getFile (file, fileList) {
      var _this = this
      _this.getBase64(file.raw).then(resu => {
        let url = _this.APIurl.API.api.up_baimg;
        let params = { base64: resu };
        _this
          .$postform(url, params).then(res => {
            console.log(res);
            if (res.code == 1)
            {
              _this.form.cover_url = res.posts[0].image
              _this.imageUrls = res.posts[0].domain + "/" + res.posts[0].image
            } else
            {
              _this.$message({
                message: "上传失败",
                type: "error",
                duration: 1000,
              });
            }
          })
      })
    },
    getFiles (file, fileList) {
      var _this = this
      _this.getBase64(file.raw).then(resu => {
        let url = _this.APIurl.API.api.up_baimg;
        let params = { base64: resu };
        _this
          .$postform(url, params).then(res => {
            console.log(res);
            if (res.code == 1)
            {
              _this.form.banner = res.posts[0].image
              _this.imageUrlss = res.posts[0].domain + "/" + res.posts[0].image
            } else
            {
              _this.$message({
                message: "上传失败",
                type: "error",
                duration: 1000,
              });
            }
          })
      })
    },
    /* 提交 */
    onSubmit () {
      var _this = this
      var url = _this.APIurl.API.api.savefenxaing
      var params = _this.form
      _this.$post(url, params).then(res => {
        console.log(res);
        if (res.code == 1)
        {
          _this.$message({
            message: '保存成功',
            type: 'success',
            duration: 1000
          });
          _this.$router.push("/admin/Special")
        } else
        {
          _this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      })
    },
    /* 取消提交 */
    nosubmit () {
      this.$router.push("/admin/Special")
    },
    /* 编辑反显 */
    getedit () {
      var _this = this
      var url = _this.APIurl.API.api.esitfenxiang
      var params = {
        id: _this.form.id
      }
      _this.$get(url, params).then(res => {
        if (res.code == 1)
        {
          _this.imageUrls = res.posts.cover_url
          _this.imageUrlss=res.posts.banner
          _this.form.cover_url = res.posts.cover_url
          _this.form.banner = res.posts.banner
          _this.form.title = res.posts.title
          _this.form.desc = res.posts.desc
          _this.form.list_order = res.posts.list_order
          _this.form.id = res.posts.id
          _this.form.status = res.posts.status
          _this.form.nav_order = res.posts.nav_order
          _this.form.is_nav = res.posts.is_nav
            _this.form.template = res.posts.template
        }
      })


    },
  }
}
</script>
<style scoped>
.box {
  padding: 30px 15px 0px 15px;
}
.avatar-uploader /deep/ .el-upload {
  background-color: white;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
